import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

import { getShopForPolicy } from 'core'
import { User } from 'core/application/account/loginUser'
import getFamilyAllowanceForCurrentUser from 'core/application/benefit/getFamilyAllowanceForCurrentUser'

import { Button, Card, Col, Row, Skeleton } from 'common/components'
import { useQueryRequestV2 } from 'common/hooks'

import RemodelHealthFullImage from '../../../assets/images/ShopForPolicyRemodelHealthFullSize.jpg'
import BackgroundImage from '../../../assets/images/shopForPolicyBackground.svg'
import SubmitToAgentModal from './SubmitToAgentModal'

type ShopForPolicyProps = {
  user: User
  isIchra?: boolean
}

const REMODEL_HEALTH_URL = 'https://remodelhealth.com/peoplekeep/advising/'

const ShopForPolicy = ({ user, isIchra = false }: ShopForPolicyProps) => {
  const { t: translate } = useTranslation()
  const [isSubmitToAgentModalVisible, setIsSubmitToAgentModalVisible] = useState(false)

  const { data: allowance } = useQueryRequestV2({
    initialState: null,
    queryFn: () => getFamilyAllowanceForCurrentUser(),
  })
  const { data: shopForPolicyInfo, isLoading: shopForPolicyLoading } = useQueryRequestV2({
    initialState: null,
    queryFn: () => getShopForPolicy(),
  })

  const isRemodelHealthUrl = REMODEL_HEALTH_URL === shopForPolicyInfo?.url

  const handleUrlRedirect = (url: string) => {
    if (!url.match(/^https?:\/\//i)) {
      window.open('http://' + url, '_blank')
    } else window.open(url, '_blank')
  }

  const handleShopNowButtonClick = () => {
    if (!!shopForPolicyInfo?.url) {
      isRemodelHealthUrl && pendo.track('Remodel Enroll now')
      handleUrlRedirect(shopForPolicyInfo?.url)
    } else {
      pendo.track('Stride Enroll now')
      window.open(
        `https://peoplekeep.stridehealth.com/health/profile/location/?zipcode=${user.companyZipCode}&hraContribution=${allowance?.allowance}&utm_term=${user.userId}`,
        '_blank',
      )
    }
  }

  const externalLinkButton = (
    <Button
      icon="fas fa-external-link"
      iconPosition="right"
      type="default"
      data-testid="shop-for-policy-cta"
      className="button__large login--login-button pt-8"
      // onClick={() => {
      //   setIsSubmitToAgentModalVisible(true);
      // }}
      onClick={() => handleShopNowButtonClick()}
    >
      {translate('admin-dashboard.shop-for-policy.button')}
    </Button>
  )

  const backgroundCardStyle = {
    backgroundImage: `linear-gradient(rgba(255,255,255,0.85), rgba(255,255,255,0.85)), url(${RemodelHealthFullImage})`,
    border: '1px solid #DBD1DE',
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }

  const cardStyle = {
    backgroundImage: `linear-gradient(250.14deg, rgba(17, 209, 117, 0.33) -5.6%, #0BB761 112.45%)`,
    border: '1px solid #DBD1DE',
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundPosition: 'right',
    backgroundSize: 'contain',
  }

  return (
    <Skeleton loading={shopForPolicyLoading} active>
      {shopForPolicyInfo && (
        <Card style={isRemodelHealthUrl ? backgroundCardStyle : cardStyle}>
          <h3 className={classNames(isRemodelHealthUrl ? '' : 'color-white', 'text-semi-bold')}>
            {shopForPolicyInfo?.title}
          </h3>
          <div className="flex flex__space_between">
            <div className="flex flex__column flex__space_between mr-16">
              <div className={classNames(isRemodelHealthUrl ? '' : 'color-white')}>
                <Row>
                  <Col sm={24} xxl={isRemodelHealthUrl ? 12 : 24}>
                    <p className="font-16">{shopForPolicyInfo?.description} </p>
                  </Col>
                </Row>
              </div>

              <div className="flex"> {externalLinkButton}</div>
            </div>
            {!isRemodelHealthUrl && !!shopForPolicyInfo && <img alt="background image" src={BackgroundImage} />}
          </div>
          <SubmitToAgentModal isVisible={isSubmitToAgentModalVisible} setIsVisible={setIsSubmitToAgentModalVisible} />
          {/* <Modal visible={openModal} onCancel={() => setOpenModal(false)} width={440} footer={false}>
            <div className={'pt-16'}>
              {<img className="pb-16" alt="image" src={StrideModalImage} width={'100%'} />}
              <div className="text-center">
                <h4>{translate('admin-dashboard.shop-for-policy.header')}</h4>
                <p>{translate('admin-dashboard.shop-for-policy.description-modal')}</p>
                <Divider />

                <Button
                  data-testid={'take-me-to-stride-cta'}
                  type="primary"
                  onClick={() =>
                    window.open(
                      `https://peoplekeep.stridehealth.com/health/profile/location/?zipcode=${user.companyZipCode}&hraContribution=${allowance?.allowance}&utm_term=${user.userId}`,
                      '_blank',
                    )
                  }
                >
                  Take me to Stride
                </Button>
              </div>
            </div>
          </Modal> */}
        </Card>
      )}
    </Skeleton>
  )
}

export default ShopForPolicy
